import type { ReactNode } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/figmaColors";
import { typographies } from "../../../styles/figmaTypographies";

export interface SectionLabelProps {
  children: ReactNode;
}

export const SectionLabel = ({ children }: SectionLabelProps) => (
  <StyledSectionLabel>{children}</StyledSectionLabel>
);

const StyledSectionLabel = styled.span`
  ${typographies["Header/H6"]}
  color: ${colors["colors/text/darkGrey"]};
  text-transform: uppercase;
`;
